import { SegmentedControl } from '@mantine/core';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { BudgetTracking } from 'src/Components/Expenses/BudgetTracking';
import { BudgetWizard } from 'src/Components/Expenses/BudgetWizard';
import { useHasPermission } from 'src/Hooks/Shared/useHasPermission';

import styles from './BudgetYearPanel.module.scss';
import { BudgetMode, Props } from './BudgetYearPanel.types';

const BudgetYearPanel = ({ year }: Props) => {
  const { t } = useTranslation();
  const { hasPermission: canManageFinance } = useHasPermission('financeAdmin', 'full');

  // « Préparer » is not merely disabled for a co-owner: it is not part of his screen at all.
  const [mode, setMode] = useState<BudgetMode>('prepare');
  const effectiveMode: BudgetMode = canManageFinance ? mode : 'track';

  return (
    <div className={styles.container}>
      {canManageFinance ? (
        <SegmentedControl
          className={styles.toggle}
          size="md"
          radius="xl"
          value={mode}
          onChange={value => setMode(value as BudgetMode)}
          data={[
            { value: 'prepare', label: t('budgetV2.mode.prepare', '✏️ Préparer mon budget') },
            { value: 'track', label: t('budgetV2.mode.track', '👀 Suivre mon budget') },
          ]}
        />
      ) : null}

      {effectiveMode === 'prepare' ? (
        <BudgetWizard year={year} onSaved={() => setMode('track')} />
      ) : (
        <BudgetTracking year={year} />
      )}
    </div>
  );
};

export default BudgetYearPanel;
